import { render, staticRenderFns } from "./AddStatement.vue?vue&type=template&id=6fd854fa"
import script from "./AddStatement.vue?vue&type=script&lang=js"
export * from "./AddStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports